import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Dic } from 'shared/common/types';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UploadFileDialogComponent {
  uploadForm = new UntypedFormGroup({
    row: new UntypedFormControl(1, Validators.required),
    column: new UntypedFormControl('A', Validators.required),
  });

  constructor(private dialogRef: MatDialogRef<UploadFileDialogComponent>) { }

  uploadFile(fileInfo: File): void {
    const reader = new FileReader();
    reader.readAsBinaryString(fileInfo);

    reader.onload = () => {
      const workBook = XLSX.read(reader.result, { type: 'binary' });
      const worksheetName = workBook.SheetNames[0];
      const worksheetRaw = workBook.Sheets[worksheetName];
      const { row, column } = this.uploadForm.value;

      const worksheet = XLSX.utils
        .sheet_to_json<Dic<unknown>>(worksheetRaw, { header: 'A' })
        .slice(row - 1)
        .filter((item: Dic<unknown>) => !!item[column])
        .map((item: Dic<unknown>) => String(item[column]));

      this.dialogRef.close(worksheet);
    };
  }
}
